import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// 导入模块
import user from './modules/user'

Vue.use(Vuex)

// 创建持久化插件
const persistedState = createPersistedState({
  key: 'lawyer-s-state', // 存储的键名
  storage: window.localStorage, // 存储方式
  // 指定需要持久化的状态
  paths: [
    'user.token',
    'user.userInfo',
    'user.roles',
    'user.permissions',
    'user.isLogin',
    'user.timId',
  ]
})

// 创建store实例
const store = new Vuex.Store({
  // 模块
  modules: {
    user
  },
  // 严格模式，在开发环境下开启
  strict: process.env.NODE_ENV !== 'production',
  // 插件
  plugins: [persistedState]
})

export default store 